import './Footer.scss';

import { Col, Row } from 'antd';

import React from 'react';
import { images } from 'src/assets/img';

function Footer() {
	return (
		// <>
		<div>
			<div className="foot">
				<div className="container-main-footer">
					<Row className="products">
						<div className="ant-col-xl-5 ant-col-lg-5 ant-col-md-5 ant-col-sm-5 sub-footer-mob">
							<img src={images.edenredlog} className="forLogo" />
							<div className="left-content">
								<div className="parent-text-footer">
									<p className="sub-text-footer1">43rd Floor, Single Business Tower </p>
									<p className="sub-text-footer1">Business Bay</p>
									<p className="sub-text-footer1">P.O.Box 34920, Dubai, UAE </p>
								</div>
								<div className="parent-text-footer">
									<p className="sub-text-footer">T +971 (0) 4 521 4000</p>
									<p className="sub-text-footer"> E info.ae@edenred.com</p>
								</div>
							</div>
						</div>

						<div className="ant-col-xl-4 ant-col-lg-1 ant-col-md-1 ant-col-sm-0"></div>

						<div className="ant-col-xl-13 ant-col-lg-3 ant-col-md-3 ant-col-sm-8 ant-col-xs-24 sub-mob-prod">
							<ul>
								<h6 className="head">Products</h6>
								<div className="left-content">
									<li>
										<a href="https://edenred.ae/edenred-payroll/" className="links">
											Edenred Payroll
										</a>
									</li>
									<li>
										<a href="https://edenred.ae/c3pay/" className="links">
											C3Pay
										</a>
									</li>
								</div>
							</ul>
						</div>

						{/* <div className="ant-col-xl-13 ant-col-lg-10 ant-col-md-10 ant-col-sm-8 ant-col-xs-24 sub-mob-prod">
							<ul>
								<h6 className="head">Resources</h6>
								<div className="left-content">
									<li>
										<a href="www.google.com" className="links">
											ATM Locations
										</a>
									</li>
									<li>
										<a href="www.google.com" className="links">
											Careers
										</a>
									</li>
								</div>
							</ul>
						</div> */}

						<div class="ant-col-xl-2 ant-col-lg-2 ant-col-md-4 ant-col-sm-3 ant-col-xs-24 icon icon-footer">
							<img
								src={images.linkedin}
								className="forIcon"
								onClick={() => window.open('https://www.linkedin.com/company/edenred-uae/')}
							/>
							<img src={images.facebook} className="FbIcon" onClick={() => window.open('https://www.facebook.com/C3Pay')} />
						</div>
					</Row>
				</div>
				<Row className="copyRight">
					<div className="ant-col-xl-21 ant-col-lg-15 ant-col-md-8 ant-col-sm-24 ant-col-xs-24 bottom-text-footer">
						Copyright ©️ 2021 Edenred
					</div>
					{/* <div className="ant-col-xl-3 ant-col-lg-3 ant-col-md-4 ant-col-sm-8 ant-col-xs-8">Edenred Group</div>
					<div className="ant-col-xl-3 ant-col-lg-3 ant-col-md-4 ant-col-sm-8 ant-col-xs-7">Privacy Policy</div> */}
					<div
						className="ant-col-xl-3 ant-col-lg-3 ant-col-md-4 ant-col-sm-8 ant-col-xs-9 bottom-text-footer"
						style={{ display: 'flex', justifyContent: 'flex-end' }}>
						Edenred Group
					</div>
				</Row>
				{/* mobile */}
				<Row className="copyRight-mobile">
					<div style={{ display: 'flex', justifyContent: 'space-evenly', flexDirection: 'row', width: '100%' }}>
						<div className="mob-copyright">Edenred Group</div>
						{/* <div className="mob-copyright">Privacy Policy</div>
						<div className="mob-copyright">Terms of Service</div> */}
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
						<div className="mob-copyright">Copyright ©️ 2021 Edenred</div>
					</div>
				</Row>
			</div>
		</div>
	);
}

export default Footer;
